'use client';

import type { Combobox } from '@base-ui-components/react/combobox';
import { String } from 'effect';
import { useState } from 'react';

export type SearchInteraction = {
  readonly inputValue: string;
  readonly open: boolean;
  readonly onInputValueChange: NonNullable<Combobox.Root.Props<unknown>['onInputValueChange']>;
  readonly onOpenChange: NonNullable<Combobox.Root.Props<unknown>['onOpenChange']>;
  readonly close: () => void;
};

export const useSearchInteraction = (initialInputValue: string): SearchInteraction => {
  const [inputValue, setInputValue] = useState(initialInputValue);
  const [open, setOpen] = useState(false);

  const onInputValueChange: SearchInteraction['onInputValueChange'] = (nextInputValue, details) => {
    if (
      String.isEmpty(nextInputValue) &&
      (details.reason === 'input-clear' || details.reason === 'escape-key')
    ) {
      return;
    }

    setInputValue(nextInputValue);
    setOpen(String.isNonEmpty(String.trim(nextInputValue)));
  };

  const onOpenChange: SearchInteraction['onOpenChange'] = (nextOpen, details) => {
    if (nextOpen && String.isEmpty(String.trim(inputValue))) return;
    if (nextOpen === false && details.reason === 'trigger-press') return;
    setOpen(nextOpen);
  };

  const close = () => setOpen(false);

  return { inputValue, open, onInputValueChange, onOpenChange, close };
};
